import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

const PopupContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  animation: ${fadeIn} 0.3s ease-out;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const PopupTitle = styled.h2`
  margin: 0 0 16px 0;
  color: #0F172A;
  font-size: 20px;
  font-weight: 600;
  font-family: 'Inter', system-ui, sans-serif;
`;

const PopupMessage = styled.p`
  margin: 0 0 24px 0;
  color: #475569;
  font-size: 14px;
  line-height: 1.5;
  font-family: 'Inter', system-ui, sans-serif;
`;

const LoginButton = styled.button`
  background: linear-gradient(135deg, #8B5CF6 0%, #06B6D4 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Inter', system-ui, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 12px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
  }
`;

const CancelButton = styled.button`
  background: transparent;
  color: #475569;
  border: 1px solid #CBD5E1;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Inter', system-ui, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #F8FAFC;
    border-color: #CBD5E1;
  }
`;

interface LoginPopupProps {
  onLogin: () => void;
  onCancel: () => void;
}

const LoginPopup: React.FC<LoginPopupProps> = ({ onLogin, onCancel }) => {
  return (
    <PopupOverlay onClick={onCancel}>
      <PopupContainer onClick={(e) => e.stopPropagation()}>
        <PopupTitle>Authentication Required</PopupTitle>
        <PopupMessage>
          Please log in to access the chat feature. You will be redirected to the authentication page.
        </PopupMessage>
        <div>
          <LoginButton onClick={onLogin}>
            Click to Login
          </LoginButton>
          <CancelButton onClick={onCancel}>
            Cancel
          </CancelButton>
        </div>
      </PopupContainer>
    </PopupOverlay>
  );
};

export default LoginPopup;